import { z } from "zod";

import { zSchema } from "../../../../entity";

import { DateTime } from "~/shared/zod";

const zIn = zSchema
  .omit({
    id: true,
    number: true,
    status: true,
    cost: true,
    createdAt: true,
    payment: true,
  })
  .extend({
    moveIsScheduledFor: zSchema.shape.moveIsScheduledFor.superRefine(
      DateTime.REFINEMENTS.notInThePast,
    ),
    services: z.array(
      zSchema.shape.services.element.pick({
        id: true,
        quantity: true,
      }),
    ),
  });
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
